import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersionStringComponent } from '../version-string/version-string.component';
import { CurrentUserComponent } from '../current-user/current-user.component';
import { CapicheMaterialModule } from 'capiche-material';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, CapicheMaterialModule, VersionStringComponent, CurrentUserComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent {
  @Input() showCurrentUser: boolean = false;
}
